<template> 
  <div>
    <el-upload
      :action="useOss?ossUploadUrl:minioUploadUrl"
      :data="useOss?dataObj:null"
      :headers="importHeaders"
      list-type="picture-card"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
      :on-success="handleUploadSuccess"
      :on-preview="handlePreview"
      :limit="maxCount"
      :on-exceed="handleExceed"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
  // import {policy} from '@/api/oss'
  import {getStaticData} from "@/api/staticData";
  import { getToken } from '@/utils/auth'
  import commonUtils from "@/utils/commonUtils";
  import messageUtils from "../../utils/messageUtils";
  export default {
    name: 'multiUpload',
    props: {
      //图片属性数组
      value: Array,
      //最大上传图片数量
      maxCount:{
        type:Number,
        default:5
      }
    },
    data() {
      return {
        dataObj: {
          policy: '',
          signature: '',
          key: '',
          ossaccessKeyId: '',
          dir: '',
          host: ''
        },
        dialogVisible: false,
        dialogImageUrl:null,
        useOss:false, //使用oss->true;使用MinIO->false
        ossUploadUrl:'https://oss.mssbaby.com/mall/ceshiimage',
        minioUploadUrl:'http://localhost:8080/minio/upload',
        importHeaders:"",
      };
    },
    computed: {
      fileList() {
        let fileList=[];
        for(let i=0;i<this.value.length;i++){
          fileList.push({url:this.value[i]});
        }
        return fileList;
      }
    },
    created(){
      this.initData();
    },

    methods: {
      initData(){

        let mytoken = getToken();
        this.importHeaders  = {"Authorization": mytoken}
        getStaticData("").then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.minioUploadUrl = data.uploadMallImageUrl;

        })
      },
      emitInput(fileList) {
        let value=[];
        for(let i=0;i<fileList.length;i++){
          value.push(fileList[i].url);
        }
        this.$emit('input', value)
      },
      handleRemove(file, fileList) {
        this.emitInput(fileList);
      },
      handlePreview(file) {
        this.dialogVisible = true;
        this.dialogImageUrl=file.url;
      },
      beforeUpload(file) {
        if (file.size >= 5*1024 * 1024){
          messageUtils.errorMsg(this,"不能上传超过5M的图片");
          return false;
        }
        return true;

      },
      handleUploadSuccess(res, file) {
        // let url = this.dataObj.host + '/' + this.dataObj.dir + '/' + file.name;
        // if(!this.useOss){
        //   //不使用oss直接获取图片路径
        //   url = res.data.url;
        // }
        let url = res.data;

        this.fileList.push({name: file.name,url:url});
        this.emitInput(this.fileList);
      },
      handleExceed(files, fileList) {
        this.$message({
          message: '最多只能上传'+this.maxCount+'张图片',
          type: 'warning',
          duration:1000
        });
      },
    }
  }
</script>
<style>

</style>





// WEBPACK FOOTER //
// src/components/Upload/multiUpload.vue